export const COUNTRY_CODES = [
  { iso: "IN", dial: "+91", name: "India" },
  { iso: "US", dial: "+1", name: "United States" },
  { iso: "CA", dial: "+1", name: "Canada" },
  { iso: "GB", dial: "+44", name: "United Kingdom" },
  { iso: "AE", dial: "+971", name: "UAE" },
  { iso: "SA", dial: "+966", name: "Saudi Arabia" },
  { iso: "QA", dial: "+974", name: "Qatar" },
  { iso: "KW", dial: "+965", name: "Kuwait" },
  { iso: "OM", dial: "+968", name: "Oman" },
  { iso: "BH", dial: "+973", name: "Bahrain" },
  { iso: "SG", dial: "+65", name: "Singapore" },
  { iso: "MY", dial: "+60", name: "Malaysia" },
  { iso: "ID", dial: "+62", name: "Indonesia" },
  { iso: "PH", dial: "+63", name: "Philippines" },
  { iso: "TH", dial: "+66", name: "Thailand" },
  { iso: "VN", dial: "+84", name: "Vietnam" },
  { iso: "LK", dial: "+94", name: "Sri Lanka" },
  { iso: "BD", dial: "+880", name: "Bangladesh" },
  { iso: "PK", dial: "+92", name: "Pakistan" },
  { iso: "NP", dial: "+977", name: "Nepal" },
  { iso: "AU", dial: "+61", name: "Australia" },
  { iso: "NZ", dial: "+64", name: "New Zealand" },
  { iso: "ZA", dial: "+27", name: "South Africa" },
  { iso: "NG", dial: "+234", name: "Nigeria" },
  { iso: "KE", dial: "+254", name: "Kenya" },
  { iso: "GH", dial: "+233", name: "Ghana" },
  { iso: "EG", dial: "+20", name: "Egypt" },
  { iso: "MA", dial: "+212", name: "Morocco" },
  { iso: "TR", dial: "+90", name: "Türkiye" },
  { iso: "DE", dial: "+49", name: "Germany" },
  { iso: "FR", dial: "+33", name: "France" },
  { iso: "ES", dial: "+34", name: "Spain" },
  { iso: "IT", dial: "+39", name: "Italy" },
  { iso: "PT", dial: "+351", name: "Portugal" },
  { iso: "NL", dial: "+31", name: "Netherlands" },
  { iso: "BE", dial: "+32", name: "Belgium" },
  { iso: "CH", dial: "+41", name: "Switzerland" },
  { iso: "AT", dial: "+43", name: "Austria" },
  { iso: "SE", dial: "+46", name: "Sweden" },
  { iso: "NO", dial: "+47", name: "Norway" },
  { iso: "DK", dial: "+45", name: "Denmark" },
  { iso: "FI", dial: "+358", name: "Finland" },
  { iso: "PL", dial: "+48", name: "Poland" },
  { iso: "CZ", dial: "+420", name: "Czechia" },
  { iso: "RO", dial: "+40", name: "Romania" },
  { iso: "GR", dial: "+30", name: "Greece" },
  { iso: "IE", dial: "+353", name: "Ireland" },
  { iso: "UA", dial: "+380", name: "Ukraine" },
  { iso: "RU", dial: "+7", name: "Russia" },
  { iso: "IL", dial: "+972", name: "Israel" },
  { iso: "HK", dial: "+852", name: "Hong Kong" },
  { iso: "JP", dial: "+81", name: "Japan" },
  { iso: "KR", dial: "+82", name: "South Korea" },
  { iso: "CN", dial: "+86", name: "China" },
  { iso: "TW", dial: "+886", name: "Taiwan" },
  { iso: "BR", dial: "+55", name: "Brazil" },
  { iso: "MX", dial: "+52", name: "Mexico" },
  { iso: "AR", dial: "+54", name: "Argentina" },
  { iso: "CL", dial: "+56", name: "Chile" },
  { iso: "CO", dial: "+57", name: "Colombia" },
  { iso: "PE", dial: "+51", name: "Peru" },
];

export const dialFor = (iso) =>
  COUNTRY_CODES.find((c) => c.iso === (iso || "").toUpperCase())?.dial || "";

/* IP first, then the browser timezone/locale, then India. */
export const detectDial = async () => {
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (res.ok) {
      const j = await res.json();
      const dial = dialFor(j.country_code) || (j.country_calling_code || "");
      if (dial) return dial;
    }
  } catch {}
  try {
    const region = new Intl.Locale(navigator.language).region;
    const dial = dialFor(region);
    if (dial) return dial;
  } catch {}
  return "+91";
};
